import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";
import { FILTER_NAMES } from "shared";

import FilterDropdown from "../FilterDropdown";

export const TaskGroupFilters = () => {
    const { hasNoPermissionToRead } = useContext(TableContext);

    const { t } = useTranslation();

    return (
        <div
            css={css({
                "@media (max-width:839px)": {
                    flex: "0.5"
                },

                "@media (max-width:599px)": {
                    flex: "1",
                    width: "100%"
                }
            })}
        >
            <FilterDropdown
                filter={FILTER_NAMES.TaskType}
                placeholder={t("Filter##task type")}
                disabled={hasNoPermissionToRead}
            />
        </div>
    );
};
